// Centraliza el mapeo "hostname del front -> ambiente -> URLs del API".
// El bundle production se deployea sin distincion a dev/qa/prod (project.json
// no tiene fileReplacements), por eso la detección es runtime.

export type EnvKey = 'dev' | 'qa' | 'prod';

export interface EnvProfile {
  apiBaseUrl: string;
  loginUrl: string;
  /**
   * Prefijo del API Vault (OAIS). Cadena vacía = rutas relativas `/api/*`
   * (nginx del contenedor en dev/qa/prod, o proxy de `nx serve` en local).
   */
  vaultApiUrl: string;
}

export const ENV_PROFILES: Record<EnvKey, EnvProfile> = {
  dev: {
    apiBaseUrl: 'https://api-dev.centricasoluciones.com',
    loginUrl: 'https://nebula-vault-dev.centricasoluciones.com/login',
    vaultApiUrl: '',
  },
  qa: {
    apiBaseUrl: 'https://api-qa.centricasoluciones.com',
    loginUrl: 'https://nebula-vault-qa.centricasoluciones.com/login',
    vaultApiUrl: '',
  },
  prod: {
    apiBaseUrl: 'https://api.centricasoluciones.com',
    loginUrl: 'https://nebula-vault.centricasoluciones.com/login',
    vaultApiUrl: '',
  },
};

export function resolveEnvKey(): EnvKey {
  if (typeof window === 'undefined') return 'dev';
  const h = window.location.hostname;
  if (/-qa\./.test(h)) return 'qa';
  if (/-prod\./.test(h)) return 'prod';
  return 'dev';
}

export function getEnvProfile(): EnvProfile {
  const profile = ENV_PROFILES[resolveEnvKey()];

  // En desarrollo local mantenemos la navegación en el mismo origen (localhost:puerto).
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return {
        ...profile,
        loginUrl: '/login',
      };
    }
  }

  return profile;
}

/** Base URL del API Vault según hostname (mismo origen en despliegues Docker). */
export function resolveVaultApiUrl(): string {
  if (typeof window === 'undefined') {
    return '';
  }
  return getEnvProfile().vaultApiUrl;
}
